import { createFileRoute, Link } from "@tanstack/react-router";
import { LegalPage } from "@/components/site/LegalPage";
import { COMPANY } from "@/lib/company";

const URL_ = "https://www.investcapital.pt/termos-e-condicoes";

export const Route = createFileRoute("/termos-e-condicoes")({
  component: Page,
  head: () => ({
    meta: [
      { title: "Termos e Condições — InvestCapital" },
      { name: "description", content: "Condições de utilização do site investcapital.pt e do serviço de pedido de proposta de compra de imóveis." },
      { property: "og:title", content: "Termos e Condições — InvestCapital" },
      { property: "og:description", content: "Regras de utilização do site InvestCapital e dos pedidos de proposta." },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:image", content: "https://www.investcapital.pt/og-investcapital.jpg" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { name: "twitter:image", content: "https://www.investcapital.pt/og-investcapital.jpg" },
      { property: "og:url", content: URL_ },
    ],
    links: [{ rel: "canonical", href: URL_ }],
  }),
});

function Page() {
  return (
    <LegalPage title="Termos e Condições" updated="26 de outubro de 2026">

      <h2>1. Identificação</h2>
      <p>
        O site {COMPANY.site} é explorado por {COMPANY.legalName} ({COMPANY.brand}), {COMPANY.taxId ? `${COMPANY.taxLabel} ${COMPANY.taxId}, ` : ""}
        {COMPANY.addressLabel.toLowerCase()}: {COMPANY.address}, Email: {COMPANY.email} · Tel./WhatsApp: {COMPANY.phone}.
      </p>

      <h2>2. Objeto</h2>
      <p>
        O site apresenta o serviço de compra de imóveis a pronto pagamento e permite pedir, sem custos nem compromisso, uma análise e proposta.
        O envio do formulário não constitui contrato nem obriga qualquer das partes à compra ou venda.
      </p>

      <h2>3. Propostas</h2>
      <p>
        As propostas são indicativas e dependem da visita ao imóvel, da análise documental e da verificação da situação jurídica e registral.
        Qualquer negócio só se concretiza por contrato-promessa e/ou escritura assinados por ambas as partes.
      </p>

      <h2>4. Obrigações do utilizador</h2>
      <ul>
        <li>Fornecer informação verdadeira e atualizada.</li>
        <li>Enviar apenas ficheiros sobre os quais tenha direitos e que não contenham conteúdo ilícito ou malicioso.</li>
        <li>Não usar o site de forma que prejudique o seu funcionamento.</li>
      </ul>

      <h2>5. Natureza da atividade</h2>
      <p>
        A {COMPANY.brand} dedica-se à gestão e investimento imobiliário e não atua como instituição financeira, entidade credora ou intermediária
        de crédito.
      </p>

      <h2>6. Propriedade intelectual</h2>
      <p>Os textos, imagens, logótipo e restantes conteúdos do site pertencem à {COMPANY.brand} ou aos respetivos titulares e não podem ser reproduzidos sem autorização.</p>

      <h2>7. Responsabilidade</h2>
      <p>Procuramos manter a informação correta e atualizada, mas não garantimos a ausência de erros ou interrupções do site.</p>

      <h2>8. Dados pessoais</h2>
      <p>O tratamento de dados rege-se pela <Link to="/politica-de-privacidade">Política de Privacidade</Link> e pela <Link to="/politica-de-cookies">Política de Cookies</Link>.</p>

      <h2>9. Reclamações e resolução de litígios</h2>
      <p>
        Pode apresentar reclamação no <a href="https://www.livroreclamacoes.pt" target="_blank" rel="noopener noreferrer">Livro de Reclamações Eletrónico</a>.
        Em caso de litígio de consumo, pode recorrer a uma entidade de resolução alternativa de litígios, como o CNIACC — Centro Nacional de
        Informação e Arbitragem de Conflitos de Consumo (<a href="https://www.cniacc.pt" target="_blank" rel="noopener noreferrer">www.cniacc.pt</a>).
        Mais informação em <a href="https://www.consumidor.gov.pt" target="_blank" rel="noopener noreferrer">www.consumidor.gov.pt</a>.
      </p>

      <h2>10. Lei aplicável</h2>
      <p>Aplica-se a lei portuguesa.</p>
    </LegalPage>
  );
}
